export default __webpack_public_path__ + "static/media/Gif-2-blue.85bbd835.gif";